import { Tooltip, type TooltipProps } from "@fpsoftware/mvp";
import { TbHelp } from "react-icons/tb";

export function Hint(props: Omit<TooltipProps, "label">) {
  const { children, ...rest } = props;

  return (
    <Tooltip label={children} {...rest}>
      <TbHelp size="18" />
    </Tooltip>
  );
}
